import React, { useState, useEffect } from "react";
import "../App.css";
import { API_URL } from '../config.js';

const Gallery = () => {
  const [projects, setProjects] = useState([]);
  const [lightboxImg, setLightboxImg] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const projectsPerPage = 3;

  useEffect(() => {
    fetch(`${API_URL}/api/projects`)
      .then(res => res.json())
      .then(setProjects);
  }, []);

  // Berechne aktuelle Projekte
  const indexOfLast = currentPage * projectsPerPage;
  const indexOfFirst = indexOfLast - projectsPerPage;
  const currentProjects = projects.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(projects.length / projectsPerPage);

  const goToPage = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0, 0); // Nach oben scrollen
  };

  return (
    <>
      <section className="page-header">
        <h1>Bildergalerie</h1>
        <p>Inspiration für Ihr nächstes Projekt</p>
      </section>
      <section className="gallery-section">
      
      {/* Projekte anzeigen */}
      {currentProjects.map((project, idx) => (
        <div className="gallery-project" key={idx}>
          <h3>{project.title}</h3>
          {project.description && <p>{project.description}</p>}
          <div className="gallery-grid">
            {project.images.map((src, i) => (
              <img
                key={i}
                src={`${API_URL}${src}`}
                alt={`${project.title} Bild ${i + 1}`}
                className="gallery-img"
                onClick={() => setLightboxImg(`${API_URL}${src}`)}
                style={{ cursor: "pointer" }}
                loading="lazy"
              />
            ))}
          </div>
        </div>
      ))}

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="pagination">
          <button 
            onClick={() => goToPage(currentPage - 1)}
            disabled={currentPage === 1}
            className="pagination-btn"
          >
            ← Zurück
          </button>
          
          {/* Smart Pagination: Zeige nur aktuelle Seite + Neighbors */}
          {(() => {
             // Wenn weniger als 5 Seiten, zeige einfach alle
             if (totalPages <= 5) {
                return [...Array(totalPages)].map((_, index) => (
                  <button
                    key={index + 1}
                    onClick={() => goToPage(index + 1)}
                    className={`pagination-btn ${currentPage === index + 1 ? 'active' : ''}`}
                  >
                    {index + 1}
                  </button>
                ));
             }

             // Sonst berechne Range (z.B. Aktuell +/- 1)
             let start = Math.max(1, currentPage - 1);
             let end = Math.min(totalPages, currentPage + 1);

             // Sonderfälle am Anfang/Ende, damit immer mind. 3 Zahlen da sind
             if (currentPage === 1) end = 3;
             if (currentPage === totalPages) start = totalPages - 2;

             const pages = [];
             for (let i = start; i <= end; i++) {
               pages.push(i);
             }

             return (
               <>
                 {start > 1 && <span className="pagination-dots">...</span>}
                 {pages.map((page) => (
                    <button
                      key={page}
                      onClick={() => goToPage(page)}
                      className={`pagination-btn ${currentPage === page ? 'active' : ''}`}
                    >
                      {page}
                    </button>
                 ))}
                 {end < totalPages && <span className="pagination-dots">...</span>}
               </>
             );
          })()}
          
          <button 
            onClick={() => goToPage(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="pagination-btn"
          >
            Weiter →
          </button>
        </div>
      )}

      {/* Info */}
      <p className="pagination-info">
        Seite {currentPage} von {totalPages} 
      </p>

      {/* Lightbox */}
      {lightboxImg && (
        <div className="lightbox" onClick={() => setLightboxImg(null)}>
          <img src={lightboxImg} alt="Großansicht" className="lightbox-img" />
          <button className="lightbox-close" onClick={() => setLightboxImg(null)}>
            &times;
          </button>
        </div>
      )}
    </section>
    </>
  );
};

export default Gallery;